<template>
  <div class="card" v-show="currentCardId == 'main-image'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>自分をアピールする画像</h2>
        <p>画像をアップロードしてください、プレビューで確認できます</p>
      </div>
      <div class="card-content">
        <div
          class="edit-form-item flex justify-center align-items-stretch sp-direction-column"
        >
          <div class="rirekisho-photo-upload">
            <div
              class="rirekisho-photo-upload-image"
              v-if="formatData.mainImageSrc"
            >
              <img
                :src="formatData.mainImageSrc"
                style="width: 100%; height: auto; object-fit: contain"
              />
            </div>
            <div class="photo-upload-action" v-if="!formatData.mainImageSrc">
              <div v-if="!globalVar.isYagiPrime" style="text-align: center">
                <div
                  id="upload-photo-button"
                  @click="handleMainImageUploadClick"
                >
                  🔓️ 写真をアップロードする
                </div>
                <p style="font-size: 0.8rem; margin-top: 5px; color: #666">
                  ヤギプライムに加入して、メイン画像を設定しよう
                </p>
              </div>
              <UploadPhoto v-else @upload-photo-complete="updateMainImage" />
            </div>
            <div class="button-photo-delete">
              <el-button v-if="formatData.mainImageSrc" @click="deleteMainImage"
                >削除</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import UploadPhoto from '@/components/format-edit/UploadPhoto.vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'

defineProps<{
  currentCardId?: string
}>()

const formatData = useRirekishoFormatData()
const { vm, globalVar, yagiprimePaymentService } = useHostServices()

function updateMainImage(data: string) {
  formatData.mainImageSrc = data
}

function deleteMainImage() {
  formatData.mainImageSrc = ''
}

function handleMainImageUploadClick() {
  yagiprimePaymentService.useFeature(vm, 'main-image-upload', {
    onSuccess: () => {},
    onCancel: () => {}
  })
}
</script>
